module.exports = __webpack_public_path__ + "img/device3.35887cdf.png";